import { render, staticRenderFns } from "./PowerModuleRecord.vue?vue&type=template&id=060c7244&scoped=true&"
import script from "./PowerModuleRecord.vue?vue&type=script&lang=js&"
export * from "./PowerModuleRecord.vue?vue&type=script&lang=js&"
import style0 from "./PowerModuleRecord.vue?vue&type=style&index=0&id=060c7244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c7244",
  null
  
)

export default component.exports